// ============================================================
// SIZES - counting rungs on the size ladder (v8.297.0).
//
// SIZE_MODS answers "how much easier is this to hit"; this module
// answers "how many categories apart are these two", which is a
// different question and the one rules like Titanbane (+X damage per
// size above Average) and Grapple (+1 DoS per size step) ask.
//
// One module because there were about to be two copies: a private
// helper in predicateDamage.ts anchored on Average, and a second for
// the two-combatant case. Two copies of a ladder walk apart.
// ============================================================
import { SIZE_ORDER } from './constants';

const AVERAGE_INDEX = SIZE_ORDER.indexOf('Average');

/**
 * A size's rung, 0-based. An unknown or absent size reads as Average -
 * the honest default for a statblock that never declared one, and the
 * only reading under which an unstated size confers no advantage.
 */
export function sizeIndex(size: string | undefined | null): number {
  const idx = SIZE_ORDER.indexOf(size || 'Average');
  return idx >= 0 ? idx : AVERAGE_INDEX;
}

/** Rungs ABOVE Average, floored at zero - small things are not negatively large. */
export function sizeStepsAboveAverage(size: string | undefined | null): number {
  return Math.max(0, sizeIndex(size) - AVERAGE_INDEX);
}

/**
 * Rungs between two combatants, SIGNED: positive when `a` is the
 * larger. Antisymmetric, so a contest read from either side agrees
 * about who has the advantage and by how much.
 */
export function sizeStepsBetween(a: string | undefined | null, b: string | undefined | null): number {
  return sizeIndex(a) - sizeIndex(b);
}
